export default class AbstractVariableStrategy {
    buildVariables(queryBuilder, context) {
        if (context.variables && context.variables.length > 0) {
            context.variables.forEach(variable => {
                queryBuilder.addFilterField(variable.name, variable.type);
            })
        }
    }
}

export class QueryVariable {
    constructor(name, type) {
        this.name = name;
        this.type = type;
    }
}
